import styled, { css, keyframes } from 'styled-components';

import { shadowHard, shadowSoft } from '../../../../previewUI/styles/global.js';

const ButtonBase = styled.button`
  background: #ffc561;
  border: 1px solid #dadce0;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  color: #191d3a;
  transition: all 0.2s;

  ${(props) =>
    props.danger &&
    css`
      background: #ff9185;
      border-color: #ff9185;
    `}

  &:hover {
    //background: #ffbc49;

    ${(props) =>
      props.danger &&
      css`
        background: #ff7061;
        border-color: #ff7061;
      `}
  }

  &[disabled] {
    background: #eeeff1;
    border-color: #eeeff1;
    color: #9393a0;
    cursor: default;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const Button = styled(ButtonBase)`
  margin: 5px 0;
  padding: 0 24px;
  min-height: 62px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.56px;
  border-radius: 6px;
  //box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%);

  @media (max-width: 767px) {
    padding: 10px 15px;
  }

  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight};
    `}

  ${(props) =>
    props.small &&
    css`
      font-size: 12px;
      line-height: 18px;
      padding: 6px 10px;
      min-height: 24px;
      width: fit-content;
      max-width: 160px;
    `}

  ${(props) =>
    props.linkWhiteBtn &&
    css`
      color: #000000;
      background: #ffffff;
      border: solid 3px #000000;
    `}

  ${(props) =>
    props.linkRedBtn &&
    css`
      color: #ffffff;
      background: #fe231b;
    `}

  ${(props) =>
    props.isLoading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.emailCardButton &&
    css`
      align-self: end;
    `}

  ${(props) =>
    props.isButton &&
    css`
      min-height: 56px;
      width: 100%;
    `}

  ${(props) =>
    props.flexCenter &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}
  
  ${(props) =>
    props.viewProducts &&
    css`
      display: flex;
      align-items: center;
      text-align: left;
      color: #000;
      font-weight: bold;
      background: #e8e8e8;
      border-color: #e8e8e8;

      &:hover {
        background: #efefef;
        border-color: #efefef;
      }
    `}
  
  ${(props) =>
    props.isButtonBorder &&
    css`
      border: 2px solid ${props.textColor} !important;

      &:hover {
        border: 2px solid ${props.textColor} !important;
      }
    `}

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 767px) {
        width: ${props.width};
      }
    `}
  
  ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth} !important;
    `}
  
  ${(props) =>
    props.hasSpinner &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}
  
  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
  
  ${(props) =>
    props.btnBackgroundColor &&
    css`
      background: ${props.btnBackgroundColor};
      border-color: ${props.btnBackgroundColor === '#ffffff' && props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};
    `}

  ${(props) =>
    props.btnBackgroundColor &&
    css`
      background: ${props.btnBackgroundColor};
      border-color: ${props.btnBackgroundColor === '#ffffff' && props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};
    `}

  ${(props) =>
    props.btnOpacity &&
    css`
      background: ${props.btnBackgroundRGBA};
      border-color: ${props.btnBackgroundRGBA};
    `}
  
  
  
  &:hover {
    ${(props) =>
      props.btnBackgroundColor &&
      css`
        background: ${props.btnBackgroundColor};
        border-color: ${props.btnBackgroundColor === '#ffffff' && props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};
      `}

    ${(props) =>
      props.btnTransparent &&
      css`
        background: transparent !important;
      `}
    
    ${(props) =>
      props.borderColor &&
      css`
        border-color: ${props.borderColor};
      `}

    ${(props) =>
      props.btnOpacity &&
      css`
        background: ${props.btnBackgroundRGBA};
        border-color: ${props.btnBackgroundRGBA};
      `}
  }

  ${(props) =>
    props.btnTransparent &&
    css`
      background: transparent !important;
    `}

  ${(props) =>
    props.borderColor &&
    css`
      border-color: ${props.borderColor};
      border-width: 1px;
    `}
  
  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}
  
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}
  
  
  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      padding: 0 5px;
      top: -2px;
      right: 3px;
      max-width: 30%;
      min-height: 52px;
      max-height: 52px;
      border-radius: 30px;
      border-color: ${props.btnOpacity ? props.btnBackgroundRGBA : props.btnBackgroundColor === '#ffffff' || props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};

      @media (min-width: 767px) {
        min-width: 140px;
      }

      @media (max-width: 568px) {
        max-width: 50%;
      }
    `}
  
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}


  ${(props) =>
    props.expand &&
    css`
      padding: 0;
      margin-left: 0;
      border: none;
      background: transparent;
      text-align: left;
      min-height: 0;
      font-size: 15px;
      line-height: 21px;
      text-decoration: underline;
      color: ${props.textColor ? props.textColor : '#ffffff'};

      &:hover {
        background: transparent;
      }

      @media (max-width: 767px) {
        padding: 0;
        margin-left: 0;
      }
    `}

  ${(props) =>
    props.isHide &&
    css`
      display: none !important;
    `}


  ${(props) =>
    props.buttonLink &&
    css`
      margin: 10px 0;
      width: 100%;
      min-height: 68px;
      padding: 12px 40px !important;
      transform: translate(0);
      backface-visibility: hidden;
      word-wrap: break-word;

      border-radius: 40px !important;

      &:hover {
        border-radius: 40px !important;
      }

      &:hover {
        background: ${props.btnBackgroundColor};
        border-color: ${props.btnBackgroundColor};
      }

      @media (max-width: 767px) {
        margin: 10px 0;
        width: 100%;
        padding: 17px 25px !important;
      }

      ${(props) =>
        props.rightArrow !== 'none' &&
        css`
          @media (max-width: 767px) {
            padding: 17px 45px !important;
          }
        `}

      ${(props) =>
        !props.isButtonBorder &&
        css`
          border: none !important;

          &:hover {
            border: none !important;
          }
        `}

    ${(props) =>
        props.cover &&
        css`
          position: relative;
          background: url(${props.cover}) no-repeat center / cover;

          &:hover {
            background: url(${props.cover}) no-repeat center / cover;
          }

          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${props.btnBackgroundColor};
            opacity: 0.2;
          }
        `}
    `}
  
  ${(props) =>
    props.isImageButtonLink &&
    css`
      position: relative;
      padding-left: 70px !important;
      padding-right: 70px !important;

      @media (max-width: 797px) {
        padding-left: 70px !important;
        padding-right: 70px !important;
      }
    `}

  ${(props) =>
    props.isDisplayArrow &&
    css`
      position: relative;
      padding-right: 40px !important;

      @media (max-width: 797px) {
        padding-right: 40px !important;
      }
    `}


  ${(props) =>
    props.isImageModeFull &&
    css`
      padding-left: 38% !important;
      padding-right: 15% !important;

      @media (max-width: 767px) {
        padding-left: 38% !important;
        padding-right: 15% !important;
      }
    `}
  
  ${(props) =>
    props.modalViewPost &&
    css`
      border-color: ${props.btnBackgroundColor === '#ffffff' ? '#dadce0' : props.btnOpacity ? props.btnBackgroundRGBA : props.btnBackgroundColor};

      &:hover {
        border-color: ${props.btnBackgroundColor === '#ffffff' ? '#dadce0' : props.btnOpacity ? props.btnBackgroundRGBA : props.btnBackgroundColor};
      }
    `}

  ${(props) =>
    props.basketButton &&
    css`
      background: #000;
      color: #fff;
      border-color: #000000;
      margin-top: 10px;
      justify-content: center;
      align-items: center;
      display: flex;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
        border-color: #000000;
      }
    `}
  
  ${(props) =>
    props.lookButton &&
    css`
      background: #2858d1;
      max-height: 50px;
      height: 50px;
    `}

  ${(props) =>
    props.directMessage &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
    `}

  ${(props) =>
    props.formLinkButton &&
    css`
      background: #fff;
      color: #000;
      border-color: #000;

      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;

      &:hover {
        background: rgba(255, 255, 255, 0.8);
        border-color: #000;
      }
    `}


  ${(props) =>
    props.directMessageModal &&
    css`
      background: #f1f1f1;
      color: #000;
      font-weight: bold;
      border-color: #f1f1f1;

      &:hover {
        background: rgba(238, 238, 238);
        color: #000;
        font-weight: bold;
        border-color: #f1f1f1;
      }

      &:active {
        background: rgba(231, 231, 231);
        color: #000;
        font-weight: bold;
        border-color: #f1f1f1;
      }
    `}

  ${(props) =>
    props.popupHero &&
    css`
      margin: 0;
      border-radius: 0;

      @media (min-width: 768px) {
        border-radius: 5px;
      }
    `}

  ${(props) =>
    props.popupWelcome &&
    css`
      margin: auto 0 30px 0;
      border-radius: 30px;
      font-size: 18px;

      @media (min-width: 767px) {
        flex-direction: row;
        padding: 0;
      }
    `}

  ${(props) =>
    props.popupCategory &&
    css`
      margin-left: 12px;
      height: 40px;
      min-height: 40px;
    `}

  ${(props) =>
    props.popupHeroActionButton &&
    css`
      margin-bottom: 70px;

      @media (max-width: 768px) {
        width: 89%;
        margin-left: auto;
        margin-right: auto;
        display: block;
      }

      @media (min-width: 768px) {
        margin-top: 30px;
        margin-bottom: 20px;
      }
    `}

  ${(props) =>
    props.itemAddedCart &&
    css`
      text-transform: uppercase;
      min-height: 38px;
      font-size: 12px;

      @media (max-width: 768px) {
        min-height: 38px;
        font-size: 11px;
        height: 38px;
        line-height: 38px;
        padding: 0 !important;
      }

      @media (max-width: 568px) {
        width: 48%;
      }
    `}
  
  ${(props) =>
    props.isInsideDashboard &&
    css`
      text-transform: uppercase;
      font-size: 11px;
      height: 38px;
      line-height: 38px;
      padding: 0 !important;
      width: 48%;
    `}

  ${(props) =>
    props.textTitle &&
    css`
      margin-top: 8px;
      padding-top: 8px;
      padding-bottom: 8px;
      width: 100%;
      min-height: 32px;
      font-size: 14px;
      border-radius: 28px;

      @media (max-width: 767px) {
        padding: 7px 15px !important;
      }
    `}

  ${(props) =>
    props.onlyHeroButton &&
    css`
      margin: 0 auto;
    `}

  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius} !important;
    `}

  ${(props) =>
    props.emailModal &&
    css`
      border-radius: 50px;
      height: 54px;
      max-height: 54px;
      min-height: 54px;
      border: none !important;
      //text-transform: uppercase;
      font-weight: bold;
    `}

  ${(props) =>
    props.textTransform &&
    css`
      text-transform: ${props.textTransform};
    `}

  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}
  


  ${(props) =>
    props.isWhiteBG &&
    css`
      //color: #000;
      box-shadow: 0 4px 8px rgb(121 121 121 / 37%);
    `}


  ${(props) =>
    props.whiteButton &&
    css`
      margin-top: -15px;
      background: #fff;
      color: #000;
      font-weight: bold;
      border-color: #fff;

      &:hover {
        background: rgba(238, 238, 238);
        color: #000;
        font-weight: bold;
        border-color: #fff;
      }

      &:active {
        background: rgba(231, 231, 231);
        color: #000;
        font-weight: bold;
        border-color: #f1f1f1;
      }

      box-shadow: 0 4px 8px rgb(121 121 121 / 37%);
    `}

  

  ${(props) =>
    props.tikTokShowMore &&
    css`
      @media (min-width: 797px) {
        margin: 0 auto;
      }
    `}
  
  ${(props) =>
    props.modalButton &&
    css`
      padding: 10px 45px !important;
      white-space: normal !important;
    `}


  ${(props) =>
    props.debitCreditCard &&
    css`
      min-height: 55px !important;
      height: 55px;
      padding: 0 30px;
    `}
  
  ${(props) =>
    props.buttonHeight &&
    css`
      min-height: ${props.buttonHeight}px !important;
      //max-height: ${props.buttonHeight}px !important;
    `}

  ${(props) =>
    props.isImage &&
    props.buttonHeight < 60 &&
    css`
      min-height: 60px !important;
    `}

  ${(props) =>
    props.marginLeftRightAuto &&
    css`
      margin-left: auto;
      margin-right: auto;
    `}

 

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;

      @media (max-width: 797px) {
        padding: ${props.padding} !important;
      }
    `}

  ${(props) =>
    props.paddingTop &&
    css`
      padding-top: ${Number(props.paddingTop) + 12}px !important;

      @media (max-width: 797px) {
        padding-top: ${Number(props.paddingTop) + 12}px !important;
      }
    `}

  ${(props) =>
    props.buttonCardImage &&
    css`
      padding-left: 12px !important;
      padding-right: 32px !important;

      @media (max-width: 797px) {
        padding-left: 12px !important;
        padding-right: 32px !important;
      }
    `}

  ${(props) =>
    props.isInsidePreview &&
    css`
      width: 100% !important;
    `}

  ${(props) =>
    props.blackButton &&
    css`
      margin-left: 5px;
      color: #fff;
      background: #000;
      border-color: #000;
      font-size: 14px;

      &:hover {
        background: #000;
        border-color: #000;
      }

      @media (max-width: 767px) {
        background: #000;
      }
    `}
  
  ${(props) =>
    props.isWhatsApp &&
    css`
      min-width: 50%;
    `}
  
  ${(props) =>
    props.back &&
    css`
      background: #000;
      color: #fff;
      font-weight: bold;
      border-color: #000;
      font-size: 14px;
      border-radius: 28px;
      width: 204px;
      height: 42px;
      min-height: 42px;
      min-width: 204px;
      text-align: center;
      padding: 0;
    `}

    ${(props) =>
    props.buttonShadowType === 'soft' &&
    css`
      ${shadowSoft};
    `}
    
    ${(props) =>
    props.buttonShadowType === 'hard' &&
    css`
      ${shadowHard};

      &:hover {
        border: 2px solid rgb(0, 0, 0) !important;
        box-shadow: rgb(0 0 0) 8px 8px 0px 0px;
      }
    `}
      ${(props) =>
    props.buttonShape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
    
      ${(props) =>
    props.buttonShape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

    ${(props) =>
    props.buttonBorder === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
    ${(props) =>
    props.buttonBorder === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

      ${(props) =>
    props.buttonShadow === 'hard' &&
    css`
      box-shadow: ${props.buttonShadowColor} 8px 8px 0 0;
    `}
      ${(props) =>
    props.buttonShadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  
      ${(props) =>
    props.buttonShadow === 'hard' &&
    props.buttonBorder === 'double' &&
    css`
      box-shadow:
        ${props.buttonShadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

const LongButtonMix = css`
  display: block;
  width: 100%;
  height: 40px;
`;

export const ButtonLong = styled(ButtonBase)`
  ${LongButtonMix};
`;

const ButtonOutlinedMix = css`
  background: white;
  border-color: #191d3a;

  &:hover {
    background: #e8e8e8;
  }
`;

export const ButtonOutlined = styled(Button)`
  ${ButtonOutlinedMix};
`;

export const ButtonLongOutlined = styled(ButtonLong)`
  ${ButtonOutlinedMix};
`;

export const ButtonWebsite = styled(ButtonBase)`
  min-width: 80px;
  max-height: 56px;
  overflow: hidden;
  padding: 2px 10px;
  background: transparent;
  border-radius: 6px;
  border: none;

  ${(props) =>
    props.isInsidePromoBar &&
    css`
      margin: 0 auto;
    `}

  ${(props) =>
    props.isInsidePreview &&
    css`
      width: 100% !important;
    `}

  ${(props) =>
    props.isInsidePreview &&
    props.isInsideHeader &&
    css`
      min-width: 55px;
    `}
  
  ${(props) =>
    props.buttonShadowType === 'soft' &&
    css`
      box-shadow: 0 4px 4px 0 rgb(0 0 0 / 16%);
    `}

  ${(props) =>
    props.buttonShadowType === 'hard' &&
    css`
      box-shadow: 4px 4px 0 0 #282f37;
    `}

  ${(props) =>
    props.isOneStyleButton &&
    css`
      max-height: 45px !important;
      height: 45px !important;
      white-space: nowrap;
      max-width: 260px !important;
      width: 260px !important;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.isInsideHeader &&
    css`
      height: auto !important;
      width: auto !important;
      max-height: 35px !important;
      min-height: 35px !important;
      max-width: 105px !important;
    `}

  ${(props) =>
    props.insideBio &&
    css`
      height: 45px;

      @media (min-width: 568px) {
        min-width: 300px;
        display: block;
        margin: 0 auto;
      }
    `}

  ${(props) =>
    props.isInsideDashboard &&
    props.isInsideHeader &&
    css`
      max-width: 105px !important;
    `}


  
  ${(props) =>
    props.isInsideDashboard &&
    props.insideBio &&
    css`
      min-width: 30px !important;
      width: 100% !important;
      display: block;
      margin: 0 auto;
    `}
  
  ${(props) =>
    props.isButtonBorder &&
    css`
      border: 2px solid rgb(${props.buttonBorderColor?.r}, ${props.buttonBorderColor?.g}, ${props.buttonBorderColor?.b}) !important;

      &:hover {
        border: 2px solid rgb(${props.buttonBorderColor?.r}, ${props.buttonBorderColor?.g}, ${props.buttonBorderColor?.b}) !important;
      }
    `}

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px !important;

      // &:hover {
      //   border-radius: 36px !important;
      // }
    `}

  ${(props) =>
    props.isInsidePromoBar &&
    css`
      height: auto !important;
      width: auto !important;
      max-height: 32px !important;
      max-width: 260px !important;
      border-radius: 6px !important;
      padding: 3px 34px !important;
    `}
  
  ${(props) =>
    props.isPulseAnimate &&
    props.btnBackgroundColorRGB &&
    !props.isButtonBorder &&
    css`
      animation: 5s ${keyframes`
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.btnBackgroundColorRGB?.r}, ${props.btnBackgroundColorRGB?.g}, ${props.btnBackgroundColorRGB?.b}, 0.7);
      }
    
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(${props.btnBackgroundColorRGB?.r}, ${props.btnBackgroundColorRGB?.g}, ${props.btnBackgroundColorRGB?.b}, 0);
      }
    
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.btnBackgroundColorRGB?.r}, ${props.btnBackgroundColorRGB?.g}, ${props.btnBackgroundColorRGB?.b}, 0);
      }`};
      animation-iteration-count: infinite;
    `}

  ${(props) =>
    props.isPulseAnimate &&
    props.btnBackgroundColorRGB &&
    props.isButtonBorder &&
    css`
      animation: 5s ${keyframes`
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.buttonBorderColor?.r}, ${props.buttonBorderColor?.g}, ${props.buttonBorderColor?.b}, 0.7);
      }
    
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(${props.buttonBorderColor?.r}, ${props.buttonBorderColor?.g}, ${props.buttonBorderColor?.b}, 0);
      }
    
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.buttonBorderColor?.r}, ${props.buttonBorderColor?.g}, ${props.buttonBorderColor?.b}, 0);
      }`};
      animation-iteration-count: infinite;
    `}
  
  &:hover {
    ${(props) =>
      props.btnBackgroundColor &&
      css`
        background: ${props.btnBackgroundColor};
        border-color: ${props.btnBackgroundColor === '#ffffff' && props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};
      `}

    ${(props) =>
      props.btnTransparent &&
      css`
        background: transparent !important;
      `}

    ${(props) =>
      props.btnOpacity &&
      css`
        background: ${props.btnBackgroundRGBA};
        border-color: ${props.btnBackgroundRGBA};
      `}
  }

  @media (min-width: 568px) {
    max-width: 280px;
  }

  @media (max-width: 568px) {
    font-size: 14px;
    padding: 3px 10px;
  }

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.isWiderCTAButton &&
    css`
      width: auto !important;
      max-width: none !important;
    `}

  ${(props) =>
    props.headerThirdType &&
    css`
      position: absolute;
      left: 12px;
      bottom: 0;
      width: calc(100% - 24px) !important;
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    props.lowerPosition &&
    css`
      bottom: 0;
    `}
  ${(props) =>
    props.isActiveButtonMessage &&
    props.headerLayout === 2 &&
    css`
      width: calc(50% - 24px) !important;
    `}
  
  ${(props) =>
    props.marginLeftRightAuto &&
    css`
      margin-left: auto;
      margin-right: auto;
    `}
  
  ${(props) =>
    props.btnBackgroundColor &&
    css`
      background: ${props.btnBackgroundColor};
      border-color: ${props.btnBackgroundColor === '#ffffff' && props.background === '#ffffff' ? '#dadce0' : props.btnBackgroundColor};
    `}
  
   ${(props) =>
    props.btnTransparent &&
    css`
      background: transparent !important;
    `}

  ${(props) =>
    Boolean(props.btnOpacity) &&
    css`
      background: ${props.btnBackgroundRGBA};
      border-color: ${props.btnBackgroundRGBA};
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      max-width: 280px;
      font-size: 14px;
      padding: 3px 10px;
    `}


  

  ${(props) =>
    Boolean(props.isInsidePreviewDashboard) &&
    css`
      width: 200px !important;
      max-width: 200px !important;
      height: 28px;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 8px 0 12px;

      @media (max-width: 568px) {
        width: 130px !important;
        max-width: 130px !important;
      }
    `}

  ${(props) =>
    props.isCTABottomPosition &&
    css`
      min-width: initial !important;
      min-height: 34px !important;
      padding: 3px 25px !important;
      margin-top: 10px;
      max-width: initial !important;
    `}
  ${(props) =>
    props.headerLayout === 2 &&
    css`
      padding: 3px 12px !important;
    `}
  
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

  ${(props) =>
    props.insideText &&
    css`
      border-radius: 6px !important;
      @media (min-width: 992px) {
        width: 380px !important;
        margin-left: auto;
        margin-right: auto;
      }

      min-height: 42px;
      max-height: initial !important;
      height: auto !important;
    `}


  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    props.isCTABottomPosition &&
    css`
      width: 100% !important;
    `}

  
  ${(props) =>
    props.headerLayout === 2 &&
    props.isScroling &&
    css`
      position: static;
      width: 80px !important;
      border-radius: 36px !important;
      padding: 3px 10px !important!;
      margin-top: 0 !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

  ${(props) =>
    props.isInsideHeader &&
    props.headerLayout === 1 &&
    css`
      max-width: 117px !important;
      box-shadow: none !important;
    `}

  ${(props) =>
    props.isInsideHeader &&
    props.headerLayout === 2 &&
    css`
      position: static !important;
      width: 100% !important;
      max-width: initial !important;
      min-width: initial !important;
      box-shadow: none !important;
      margin: 0 !important;
    `}
  
  ${(props) =>
    props.isInsideHeader &&
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    css`
      box-shadow: none !important;
      margin: 0 5px 0 0 !important;
      max-width: 130px !important;
    `}

  ${(props) =>
    props.isInsideHeader &&
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    props.isCTABottomPosition &&
    css`
      padding: 3px 12px !important;
      margin: 0 !important;
      box-shadow: none !important;
      max-width: initial !important;
      min-width: initial !important;
      width: 100% !important;
      border-radius: 8px !important;
    `}
    ${(props) =>
    props.buttonShadowType === 'soft' &&
    css`
      ${shadowSoft};
    `}
    
    ${(props) =>
    props.buttonShadowType === 'hard' &&
    css`
      ${shadowHard};

      &:hover {
        border: 2px solid rgb(0, 0, 0) !important;
        box-shadow: rgb(0 0 0) 8px 8px 0px 0px;
      }
    `}
      ${(props) =>
    props.buttonShape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
    
      ${(props) =>
    props.buttonShape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

    ${(props) =>
    props.buttonBorder === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
    ${(props) =>
    props.buttonBorder === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

      ${(props) =>
    props.buttonShadow === 'hard' &&
    css`
      box-shadow: ${props.buttonShadowColor} 8px 8px 0 0 !important;
    `}
      ${(props) =>
    props.buttonShadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  
      ${(props) =>
    props.buttonShadow === 'hard' &&
    props.buttonBorder === 'double' &&
    css`
      box-shadow:
        ${props.buttonShadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px !important;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

export const ButtonTransparent = styled.button`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;

  &:hover,
  &:focus,
  &:active {
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
  }

  ${(props) =>
    props.deleteTag &&
    css`
      position: absolute;
      bottom: 0;
      right: 0;
      margin-left: auto;
    `}
`;
